// OSS访问地址
export const OSS_DOMAIN = 'https://shendu-prod.oss-cn-beijing.aliyuncs.com'
export const OSS_PATH = '/static/yiyuan'

export default {
  REGISTER_PROTOCOL_URL: `${OSS_DOMAIN}${OSS_PATH}/pdf/注册服务协议.pdf?v=${new Date().getDate()}`,
  PRIVATE_PROTOCOL_URL: `${OSS_DOMAIN}${OSS_PATH}/pdf/隐私政策.pdf?v=${new Date().getDate()}`,
  POWER_OF_ATTORNEY: `${OSS_DOMAIN}${OSS_PATH}/pdf/授权委托书.pdf?v=${new Date().getDate()}`,
  BUSINESS_LICENSE_EXAMPLE: `${OSS_DOMAIN}${OSS_PATH}/imgs/example/business-license.jpeg?v=${new Date().getDate()}`,
  IDENTITY_CARD_FRONT_EXAMPLE: `${OSS_DOMAIN}${OSS_PATH}/imgs/example/legal-identity-front.png?v=${new Date().getDate()}`,
  IDENTITY_CARD_BACK_EXAMPLE: `${OSS_DOMAIN}${OSS_PATH}/imgs/example/legal-identity-back.png?v=${new Date().getDate()}`,
}
